import {
  Request
} from '../index'
// 用餐接口全部替换
const NewRequest = function () {
  arguments[0] = `mealsapi/${arguments[0]}`
  return Request(...arguments)
}
/* 获取用餐授权地址 */
export function kpiAccessGetFoodAddress(data = {}) {
  return NewRequest('access/getFoodAddress', 'post', undefined, data)
}

/* 订单初始化接口 */
export function kpiAppOrderFillingOrder(data = {}) {
  return NewRequest('appOrder/fillingOrder', 'post', undefined, data)
}

/* 订单初始化校验接口 */
export function kpiAppOrderCheckRepeat(data = {}) {
  return NewRequest('appOrder/checkRepeat', 'post', undefined, data)
}

/* 差标校验接口 */
export function kpiAppOrderCheckReasonCode(data = {}) {
  return NewRequest('appOrder/checkReasonCode', 'post', undefined, data)
}

/* 订单提交 */
export function kpiAppOrderConfirmOrder(data = {}) {
  return NewRequest('appOrder/confirmOrder', 'post', undefined, data)
}

/* 订单列表查询 */
export function kpiAppOrderList(data = {}) {
  return NewRequest('appOrder/list', 'post', undefined, data)
}

/* 用餐订单详情接口 */
export function kpiAppOrderDetails(data = {}) {
  return NewRequest('appOrder/details', 'post', undefined, data)
}

/* 订餐人快捷查询 */
export function kpiAppOrderGetDinnerList(data = {}) {
  return NewRequest('appOrder/getDinnerList', 'post', undefined, data)
}

/* 用餐下单页支付金额计算 */
export function kpiAppOrderGetPaymentAmountByUser(data = {}) {
  return NewRequest('appOrder/getPaymentAmountByUser', 'post', undefined, data)
}

/* 用餐下单页支付金额计算 */
export function kpiPayDoPay(data = {}) {
  return NewRequest('pay/doPay', 'post', undefined, data)
}

/* 获取用餐职级列表 */
export function kpiGetDiningRanks(data = {}) {
  return Request('diningRank/getDiningRanks', 'post', undefined, data)
}
/* 获取用餐职级详情 */
export function kpiGetDiningRank(data = {}) {
  return Request('diningRank/getDiningRank', 'post', undefined, data)
}
/* 获取用餐职级详情 */
export function kpiHomsomRankDining(data = {}) {
  return Request('homsomRank/dining', 'post', undefined, data)
}
